import { isType } from '../../helpers'
import Rule from './Rule'

export default class Siren extends Rule {
  get ruleName () {
    return 'siren'
  }

  passes () {
    if (!isType(this.value, 'string')) return false

    /* cf. https://fr.wikipedia.org/wiki/Syst%C3%A8me_d%27identification_du_r%C3%A9pertoire_des_entreprises */
    /* filter spaces */
    let siren = [...this.value].filter((char) => char !== ' ')
    if (isNaN(parseInt(siren.join()))) return false

    /* Convert to number */
    siren = siren.map((number) => parseInt(number))

    function convertToDigit (number) {
      if (number > 9) {
        number = String(number)
        return parseInt(number[0]) + parseInt(number[1])
      }
      return number
    }

    siren = siren.map((number, index) => (index % 2
      ? convertToDigit(number * 2)
      : number)).reduce((acc, current) => acc + current)
    return !(siren % 10)
  }
}
